import { render, staticRenderFns } from "./CYXW.vue?vue&type=template&id=4c7e75fd&scoped=true&"
import script from "./CYXW.vue?vue&type=script&lang=js&"
export * from "./CYXW.vue?vue&type=script&lang=js&"
import style0 from "./CYXW.vue?vue&type=style&index=0&id=4c7e75fd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7e75fd",
  null
  
)

export default component.exports